<template>
  <div class="common-page staff-management">
    <div class="search-form-box">
      <el-row :gutter="30">
        <el-form inline>
          <el-col :span="5">
            <el-form-item label="账号搜索:">
              <el-input
                style="width: 100%"
                clearable
                v-model="searchForm.keyword"
                autocomplete="off"
                placeholder="手机号码/姓名" />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="角色:">
              <el-select style="width: 100%" clearable v-model="searchForm.roleId" placeholder="选择角色">
                <el-option
                  v-for="item in roleData"
                  :key="item.roleId"
                  :label="item.roleName"
                  :value="item.roleId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="状态:">
              <el-select style="width: 100%" clearable v-model="searchForm.status" placeholder="选择状态">
                <el-option
                  v-for="item in $dict.statusOptions"
                  :key="item.dictCode"
                  :label="item.dictLabel"
                  :value="item.dictCode"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="">
              <el-button type="primary" round icon="el-icon-search" @click="handleCheck()"></el-button>
              <el-button type="default" round icon="el-icon-refresh" @click="handleReset()"></el-button>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
    </div>
    <div class="search-table-box">
      <el-button type="primary" @click="handleAdd()">新增账号</el-button>
    </div>
    <div class="custom-table-box">
      <custom-table
        :data="tableData"
        :column="tableColumn"
        :total="tableOptions.total"
        :loading="tableOptions.loading"
        :page="tableOptions.pageNumber"
        :size="tableOptions.pageSize"
        :selection="false"
        @pagination="handleSizeChange">
        <template v-slot:status="{ row }">
          <span @click="handleStatus(row)" v-if="!row.internal">
            <el-switch
              :value="row.status"
              :inactive-value="0"
              :active-value="1"
              size="medium"
              active-color="#526BEC"></el-switch>
          </span>
        </template>
        <template v-slot:operation="{ row }">
          <div v-if="!row.internal">
            <span class="operate-btn" @click.stop="handleEdit(row)">编辑</span>
            <span class="operate-btn colorf32009" @click="handleDelete(row.userId, '确定要删除此账号吗？')">删除</span>
          </div>
        </template>
      </custom-table>
    </div>

    <!--    添加或编辑-->
    <addOrEdit ref="addOrEdit"></addOrEdit>
  </div>
</template>

<script>
import OperateBox from "@/components/OperateBox.vue";
import CustomTable from "@/components/CustomTable.vue";
import addOrEdit from "./addOrEdit.vue";
import { deleteInfo, enableUser, getPage } from "./api";
import tableMixin from "@/mixin/tableMixin";
import { getRoleSelect } from "@/views/commonApi";
export default {
  name: "Staff-management",
  mixins: [tableMixin],
  components: {
    OperateBox,
    CustomTable,
    addOrEdit,
  },
  data() {
    return {
      getTableMethod: getPage,
      deleteMethod: deleteInfo,
      isImmediatelyGetData: false,
      searchForm: {
        keyword: "",
        terminalType: "1",
        roleId: "",
        status: "",
      },
      orgId: [],
      departTree: [], // 部门树
      tableColumn: [
        {
          label: "账号",
          prop: "account",
          show: true,
        },
        {
          label: "手机号",
          prop: "phone",
          show: true,
        },
        {
          label: "姓名",
          prop: "username",
          show: true,
        },
        {
          label: "角色名称",
          prop: "roleName",
          show: true,
        },
        {
          label: "状态",
          prop: "status",
          scopeStatus: true,
          show: true,
        },
        {
          label: "操作",
          prop: "operation",
          fixed: "right",
          width: "150px",
          scopeStatus: true,
          show: true,
        },
      ],
      multipleSelection: [],
      roleData: [],
    };
  },
  watch: {
    "searchForm.terminalType": {
      handler(val) {
        this.getRoleData(val);
        this.searchForm.roleName = "";
        this.searchForm.roleId = "";
        this.searchForm.status = "";
        this.searchPage();
      },
    },
  },
  created() {
    this.getRoleData(1);
  },
  mounted() {},
  methods: {
    getRoleData(terminalType) {
      getRoleSelect(terminalType).then((res) => {
        if (res.code === 200) {
          this.roleData = res.data;
        }
      });
    },
    handleReset() {
      this.searchForm.keyword = "";
      this.searchForm.roleName = "";
      this.searchForm.status = "";
      this.tableOptions.currentPage = 1;
      this.searchPage();
    },
    handleAdd() {
      this.$refs.addOrEdit.init(this.searchForm.terminalType);
    },
    handleEdit(row) {
      this.$refs.addOrEdit.init(this.searchForm.terminalType, row);
    },
    handleStatus(row) {
      this.$confirm(`确定${!row.status ? "启用" : "禁用"}此用户？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      }).then(() => {
        enableUser({ userId: row.userId, status: row.status ? 0 : 1 }).then(
          (res) => {
            if (res.code === 200) {
              this.getTableData();
            }
          }
        );
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.business-management {
  .search-form-title {
    font-weight: 400;
    font-size: 0.16rem;
    color: #111827;
    line-height: 0.24rem;
    padding-bottom: 0.08rem;
  }
  .drop-image {
    width: 0.24rem;
    height: 0.24rem;
  }
  .custom-table-box {
    padding-bottom: 0.68rem;
  }
}
</style>
